import { Component, OnInit, Input, AfterContentInit, AfterViewInit } from '@angular/core'
import { Observable } from 'rxjs';

@Component({
    selector: 'sbw-explorer-banner',
    templateUrl: './explore-banner.component.html'
})

export class ExploreBannerComponent implements OnInit {

    public link: string
    public description: string
    public label: string
    public visible: boolean = false

    @Input() content: Observable<any>

    ngOnInit(): void {
        this.checkVisibility()

        if (this.visible) {
            this.content.subscribe(c => {
                this.description = this.replaceTextWithLink(c.exploreBannerDescription)
                this.label = c.edgeLabel
                this.saveUrl()
            })
        }
    }

    // Generates an edge link if internet explore and windows 10
    // Sets visibility to true if internet explore and if not localstorage item exist
    public checkVisibility() {
        let ie = navigator.userAgent.includes('MSIE ') || navigator.userAgent.includes('Trident/')
        if (ie && !localStorage.getItem('ie_banner_seen')) this.visible = true
        let isW10 = navigator.userAgent.includes('Windows NT 10.0') // only works when used in ie browser
        if (isW10) {
            this.link = 'microsoft-edge:' + ( localStorage.getItem('ie_banner_url') || window.location.href )
        }
    }

    // If text contains 'Google Chrome' or 'Firefox', we replace it with a link
    public replaceTextWithLink(text: string) {
        if (text) text = text.replace('Google Chrome', '<a href="https://www.google.com/chrome/" target="_blank">Google Chrome</a>')
        if (text) text = text.replace('Firefox', '<a href="https://www.mozilla.org/en/firefox/new/" target="_blank">Firefox</a>')
        return text
    }

    // We save the url in storage, so we can reuse it if user clicks the button on one of the other steps in the flow
    public saveUrl() {
        let currentUrl = window.location.href
        let storageUrl = localStorage.getItem('ie_banner_url')
        if (!storageUrl || storageUrl && "?" + storageUrl.split('?')[1] != window.location.search) localStorage.setItem('ie_banner_url', currentUrl)
    }

    public closed(event) {
        localStorage.setItem('ie_banner_seen', 'true')
    }
}
